<template>
  <div class="export-popover">
    <div class="backdrop"></div>
    <div class="content" ref="content">
      <div class="header">
        <div class="left">
          <h2>{{$t('export.popover-title')}}</h2>
          <span>- {{ publication.name }}</span>
          <infobox bottom :width="400" class="info-box" slot="info">
            <span slot="icon">
              <i class="fa-light fa-question-circle"></i>
            </span>
            <p class="text-small description" v-html="$t('export.export-info')"></p>
          </infobox>
        </div>
        <div class="close-popover" @click="$emit('close')">
          <i class="fa-light fa-times"></i>
        </div>
      </div>

      <div class="content-wrapper">
        <div class="options">
          <button class="btn btn-secondary" @click="checkAll">{{$t('export.select-all')}}</button>
          <button class="btn btn-secondary" @click="uncheckAll">{{$t('export.unselect-all')}}</button>
          <div class="filter-search">
            <i class="fa-light fa-search search"></i>
            <input
              class="search-input"
              type="text"
              v-model="searchFilter"
              :placeholder="$t('filter') + '...'"
            />
            <div class="reset-btn" v-show="searchFilter.length !== 0" @click="searchFilter = ''">
              <i class="fa-light fa-times reset"></i>
            </div>
          </div>
        </div>

        <div>
          <div class="export-list-header">
            <div class="list-heading" @click="onToggleSort('selected')">
              <h4>{{$t('export.list-header.select')}}</h4>
              <div v-if="sortKey === 'selected'">
                <span v-show="descending">
                  <i class="fa-light fa-caret-down" />
                </span>
                <span v-show="!descending">
                  <i class="fa-light fa-caret-up" />
                </span>
              </div>
            </div>
            <div class="list-heading" @click="onToggleSort('contentID')">
              <h4>{{$t('export.list-header.id')}}</h4>
              <div v-if="sortKey === 'contentID'">
                <span v-show="descending">
                  <i class="fa-light fa-caret-down" />
                </span>
                <span v-show="!descending">
                  <i class="fa-light fa-caret-up" />
                </span>
              </div>
            </div>
            <div class="list-heading" @click="onToggleSort('name')">
              <h4>{{$t('export.list-header.name')}}</h4>
              <div v-if="sortKey === 'name'">
                <span v-show="descending">
                  <i class="fa-light fa-caret-down" />
                </span>
                <span v-show="!descending">
                  <i class="fa-light fa-caret-up" />
                </span>
              </div>
            </div>
          </div>
          <span
            class="text-muted small"
            style="padding: 0 15px;"
          >{{checkedInFilter.length + $t('export.of') + filteredExportList.length + $t('export.selected')}}</span>
        </div>

        <div class="list-wrapper custom-scrollbar-light">
          <div v-show="loading" class="loading">
            <i class="fa-light fa-circle-notch fa-spin"></i>
          </div>
          <div v-if="error">
            <p>{{$t('export.load-error')}}</p>
            <button class="btn btn-primary" @click="getDummyList()">{{$t('export.retry')}}</button>
          </div>
          <div class="list" v-show="!loading">
            <export-item
              v-for="item in limitListLength"
              :key="item.id"
              :item="item"
              @isSelected="handleSelect"
              :selectAll="selectAll"
              :deselectAll="deselectAll"
              :initiallySelected="exportModel.dataIds.includes(item.id)"
            />
            <div
              class="show-more text-small text-muted"
              v-if="listLimit != null && listLimit < orderedList.length "
            >
              <span>{{$t('export.showing') + listLimit + $t('export.of') + orderedList.length}}</span>
              <span class="list-action" @click="showMore">{{$t('export.show-more')}}</span>
              <br />
              <span class="list-action" @click="showAll">{{$t('export.show-all')}}</span>
            </div>
            <div
              class="no-data text-muted"
              v-if="filteredExportList.length == 0"
            >{{$t('export.no-data')}}</div>
            <div
              class="no-data text-muted"
              v-if="exportList.length == 0"
            >{{$t('export.no-data-uploaded')}}</div>
          </div>
        </div>

        <div class="export-options">
          <div class="inputs">
            <div class="form-group format-selector">
              <label for="format">{{$t('export.format')}}</label>
              <select
                class="form-control selector"
                id="format"
                :placeholder="$t('export.format')"
                v-model="exportModel.fileFormat"
              >
                <option value="xlsx">xlsx</option>
                <option value="csv">csv</option>
              </select>
            </div>

            <custom-input
              :inputType="'email'"
              v-model="exportModel.email"
              :name="'emailInput'"
              :label="'Email'"
              :placeholder="$t('export.email-placeholder')"
            />
          </div>
          <div class="check-wrapper">
            <checkbox
              class="check-include-all"
              lightLabel
              :label="$t('export.include-label')"
              :name="'includeExistingFields'"
              :value="exportModel.includeExistingFields"
              v-model="exportModel.includeExistingFields"
            />
            <infobox bottom :width="400" class="info-box" slot="info">
              <span slot="icon">
                <i class="fa-light fa-question-circle"></i>
              </span>
              <p class="text-small description" v-html="$t('export.include-info')"></p>
            </infobox>
          </div>

          <div class="export-actions">
            <div
              class="text-muted small"
            >{{$t('export.total-selected') + exportModel.dataIds.length}}</div>
            <button type="reset" class="btn btn-secondary" @click="$emit('close')">{{$t('cancel')}}</button>
            <button
              type="submit"
              class="btn btn-primary"
              @click="handleExport()"
              :disabled="!valid"
            >{{$t('export.send-link')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustomInput from "@/components/CustomInput";
import ExportItem from "@/components/ExportItem";
import Checkbox from "@/components/Checkbox";
import ConfirmModal from "@/components/modals/ConfirmModal";
import Infobox from "@/components/Infobox";
import orderBy from "lodash/orderBy";
export default {
  data() {
    return {
      loading: false,
      error: false,
      descending: false,
      sortKey: "name",
      exportList: [],
      searchFilter: "",
      selectAll: false,
      deselectAll: false,
      listLimit: 50,
      exportModel: {
        email: this.$store.state.user.username,
        fileFormat: "xlsx",
        includeExistingFields: false,
        contentSourceId: this.publication.sources[0].id,
        dataIds: []
      }
    };
  },
  props: {
    publication: Object
  },
  methods: {
    showMore() {
      this.listLimit = this.listLimit + 50;
    },
    showAll() {
      this.listLimit = null;
    },
    onToggleSort(sortKey) {
      this.descending = this.sortKey == sortKey ? !this.descending : false;
      this.sortKey = sortKey;
    },
    handleExport() {
      this.$store
        .dispatch("sendExportLink", {
          exportModel: this.exportModel,
          publicationId: this.publication.id
        })
        .then(res => {
          this.$modal.show(
            ConfirmModal,
            {
              title: this.$t("export.success-title"),
              description: this.$t("export.success-desc"),
              hideCancelButton: true,
              onConfirm: () => {
                this.$emit("successful-export");
              }
            },
            { width: 350, height: "auto" }
          );
        })
        .catch(err => {
          this.$modal.show(
            ConfirmModal,
            {
              title: this.$t("export.export-err-title"),
              description: this.$t("export.export-err-desc"),
              hideCancelButton: true
            },
            { width: 350, height: "auto" }
          );
        });
    },
    getDummyList() {
      this.error = false;
      this.loading = true;
      this.$store
        .dispatch("getDummyData", this.publication.sources[0])
        .then(res => {
          this.exportList = res;
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
          this.error = true;
        });
    },
    handleSelect(id) {
      if (this.exportModel.dataIds.includes(id)) {
        if (!this.selectAll) {
          this.exportModel.dataIds.splice(
            this.exportModel.dataIds.indexOf(id),
            1
          );
        }
      } else {
        this.exportModel.dataIds.push(id);
      }
    },
    checkAll() {
      this.filteredExportList.forEach(el => {
        if (!this.exportModel.dataIds.includes(el.id)) {
          this.exportModel.dataIds.push(el.id);
        }
      });
      this.selectAll = true;
      this.$nextTick(() => {
        this.selectAll = false;
      });
    },
    uncheckAll() {
      this.deselectAll = true;
      this.$nextTick(() => {
        this.exportModel.dataIds = this.exportModel.dataIds.filter(item => {
          return !this.filteredExportList
            .map(element => element.id)
            .includes(item);
        });
        this.deselectAll = false;
      });
    }
  },
  computed: {
    filteredExportList() {
      return this.exportList.filter(item => {
        return (
          item.name.toLowerCase().includes(this.searchFilter.toLowerCase()) ||
          item.contentID.toLowerCase().includes(this.searchFilter.toLowerCase())
        );
      });
    },
    orderedList() {
      this.filteredExportList.map(item => {
        item.selected = this.exportModel.dataIds.includes(item.id);
      });

      return orderBy(
        this.filteredExportList || [],
        exportList => exportList[this.sortKey],
        [this.descending ? "desc" : "asc"]
      );
    },
    checkedInFilter() {
      return this.filteredExportList.filter(item => {
        return this.exportModel.dataIds.includes(item.id);
      });
    },
    valid() {
      return (
        this.exportModel.dataIds.length > 0 && this.exportModel.email.length > 0
      );
    },
    limitListLength() {
      return this.listLimit
        ? this.orderedList.slice(0, this.listLimit)
        : this.orderedList;
    }
  },
  mounted() {
    this.getDummyList();
  },
  components: {
    ExportItem,
    Checkbox,
    CustomInput,
    Infobox
  }
};
</script>
<style lang="less">
.export-popover {
  .backdrop {
    position: fixed;
    z-index: 99;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.25);
  }
  .content {
    position: absolute;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
    width: 75%;
    height: 90%;
    left: calc(50% + (85px / 2));
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 99;
    background-color: var(--background-white);
    border-radius: var(--standard-border-radius);
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--background-white);
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
    position: relative;
    padding: 14px 24px 14px 24px;
    border-radius: 10px 10px 0 0;

    h2 {
      margin-bottom: 0;
    }
    .description {
      margin: 6px 0 0 0;
      padding: 0;
    }
    .close-popover {
      cursor: pointer;
    }

    .left {
      display: flex;
      align-items: center;
      gap: 4px;
    }
  }

  .export-list-header {
    padding: 12px 15px 0;
    display: grid;
    grid-template-columns: 200px 1fr 1fr;

    .list-heading {
      cursor: pointer;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
      h4 {
        margin: 0;
      }
    }
  }
  .content-wrapper {
    height: calc(100% - 50px);
    display: grid;
    grid-template-rows: auto auto 1fr auto;
  }
  .options {
    padding: 15px;
    display: flex;
    gap: 10px;
    padding-bottom: 20px;
    .btn {
      white-space: nowrap;
    }
  }

  .filter-search {
    width: 100%;
    font-size: 12px;
    border-radius: 20px;
    position: relative;
    padding: 0 6px;
    color: var(--charcoal-75);
    .search {
      position: absolute;
      left: 18px;
      top: 50%;
      transform: translateY(-50%);
    }
    .reset {
      position: absolute;
      right: 18px;
      top: 50%;
      transform: translateY(-50%);
    }

    .search-input {
      border: none;
      outline: none;
      font-size: 12px;
      border-radius: 20px;
      margin-right: 40px;
      box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
      padding-left: 40px;
      transition: 0.3s;
      width: 100%;
      height: 100%;
      &::placeholder {
        color: var(--charcoal-50);
      }
      &:focus,
      :active {
        outline: none;
        border: none;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
        color: var(--charcoal);
      }
    }
    .reset-btn {
      cursor: pointer;
    }
  }
  .list-wrapper {
    overflow: auto;
    padding: 4px 0;
    .loading {
      margin: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .list {
    .no-data {
      text-align: center;
      &:nth-of-type(1) {
        margin-top: 24px;
      }
    }
    .show-more {
      margin-top: 12px;
      text-align: center;

      .list-action {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }

  .export-options {
    padding: 15px;
    .format-selector {
      margin: 0;
      label {
        margin: 0;
      }
    }
    .inputs {
      display: grid;
      grid-template-columns: 1fr 1fr;
      align-items: flex-end;
      gap: 12px;
      margin-bottom: 12px;
    }

    .export-actions {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      position: relative;
      .text-muted {
        position: absolute;
        top: -24px;
        right: 6px;
      }
    }
    .check-include-all {
      width: max-content;
      margin-bottom: 0;
    }
  }
  .check-wrapper {
    margin-bottom: 14px;
    display: flex;
    align-items: center;
    gap: 4px;
    svg {
      color: var(--text-grey-primary);
    }
  }

  .info-box {
    p {
      margin: 0;
    }
    .hover-element span {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>